<!-- <chiplist-ac [control]="field.control" [searchCtrl]="searchCtrl" [caption]="field.label | localize"
[placeholder]="field.placeholder | localize" [hint]="field.hint | localize" [options]="options$"
[readonly]="field.readonly" [required]="field.required" [id]="'userId'"></chiplist-ac> -->
@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-col w-full">
      <div class="flex flex-row items-center w-full">
        @if (field.browserOpts.inLineWithCaption) {
          <mat-label class="mr-2 font-medium">
            {{ field.label | localize }}
          </mat-label>
        }
        <mat-form-field class="w-full">
          <mat-label>{{ field.label | localize }}</mat-label>
          <mat-select [formControl]="field.control" [multiple]="field.multiple" [disabled]="field.readonly">
            <div class="sticky -top-2 z-10 bg-white dark:bg-slate-800">
              <mat-form-field class="w-1/3 ml-4 mt-2 fuse-mat-emphasized-affix fuse-mat-rounded fuse-mat-dense">
                <mat-icon matPrefix [svgIcon]="'mat_outline:search'"></mat-icon>
                <input matInput [formControl]="searchCtrl" type="text" placeholder="{{ 'searchUser' | transloco }}">
              </mat-form-field>
            </div>
            @for (option of options$ | async; track option) {
              <mat-option [class.hidden]="option.hide" [value]="option.userId">
                {{ option.displayName }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  }
}